import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["durationSelect", "pg1Price", "pg2Price", "careCosts"]
  static values = { fixedCosts: Number }

  connect() {
    this.updatePrices()
  }

  updatePrices() {
    const selectedOption = this.durationSelectTarget.selectedOptions[0]
    if (!selectedOption) return
    
    // Get the raw strings from the data attributes
    const rawEigenanteil = selectedOption.dataset.eigenanteil
    const rawZuschuss = selectedOption.dataset.zuschuss

    const eigenanteil = this.parseGermanCurrency(rawEigenanteil)
    const zuschuss = this.parseGermanCurrency(rawZuschuss)

    // Calculate totals based on this logic:
    // PG1 = Eigenanteil + Zuschuss
    // PG2+ = Eigenanteil only
    const pg1Total = Math.round((eigenanteil + zuschuss) / 100.0) * 100
    const pg2Total = Math.round(eigenanteil / 100.0) * 100

    // Update
    this.pg1PriceTarget.textContent = this.formatPrice(pg1Total)
    this.pg2PriceTarget.textContent = this.formatPrice(pg2Total)

    if (this.hasCareCostsTarget) {
      const careCost = pg2Total - this.fixedCostsValue
      this.careCostsTarget.textContent = this.formatPrice(careCost) + ' €'
    }
  }


  parseGermanCurrency(str) {
    if (!str) return 0
    
    // Remove everything that isn't a digit or a comma
    
    const cleanStr = str.replace(/[^\d,]/g, '')
    
    // Replace the decimal comma with a dot
    const dotStr = cleanStr.replace(',', '.')
    
    return parseFloat(dotStr) || 0
  }

  formatPrice(value) {
    return Math.round(value).toLocaleString('de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })
  }
}